<template>
    <div class="main-box">
        <Head></Head>
        <h2 style="text-align: center;font-size: 30px;padding: 20px;font-weight: bold;">广东富弈广告有限公司©版权所有</h2>
        <HeadTitle :logoUrl="foot.logoUrl" :titleUrl="foot.titleUrl"></HeadTitle>
        <Menu :menus="menus"></Menu>
        <Banner :list="bannerList" :height="600" :showCover="true" :showBtn="true"></Banner>
        <Entry :entry="entrys"></Entry>
        <router-view>
        </router-view>
        <Footer :foot="foot" :qrcodeList="qrcodeList"></Footer>
    </div>
</template>

<script>

import { MessageBox } from "mint-ui"
import Banner from "../components/Banner"
import Entry from "../components/Entry"
import Head from '../components/Head'
import HeadTitle from '../components/HeadTitle'
import Menu from "../components/Menu"
import Content from "./Content"
import Footer from "../components/Footer"
import Beian from "../components/Beian"

export default {
    name:'Index',
    data(){
        return {
            foot:{},
            bannerList:[],
            newsList:[],
            menus:[],
            entrys:[],
            qrcodeList:[]
        }
    },
    components:{
        Head, HeadTitle, Menu, Footer, Content, Beian, Banner, Entry
    },
    mounted(){
        this.getEntrys();
        this.getBanners();
        this.getMenus();
        this.getFooter();
        this.getQrcodeList();
    },
    methods:{
        getBanners(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=0").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bannerList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getEntrys(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=8").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.entrys = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getMenus(){
            const self = this;
            this.$http.get("/bicycle/inter/menus").then(function(res){
                if(res.data.status != 200){
                    MessageBox(res.data.errorMsg);
                }else{
                    self.menus = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
         getQrcodeList(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=7").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.qrcodeList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getFooter(){
            const self = this;
            this.$http.get("/bicycle/inter/footer").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.foot = res.data.data;

                    document.title = self.foot.title || '';
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>

<style scoped>
.middle-pic{
    max-width: 1920px;
    min-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 40px;
}
.logo-block{
    background-color: #E6E6E6;
    width: 1200px;
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/Index.vue